define('productAlternativesView',['module',
    'marionette',
    'app',
    'underscore',
    'productAlternativeView',
    'template!productAlternativesTpl',
    'pimProductSelectDialogView',
    'entities/pim_product_alternative'
  ],
  function (module,
            Marionette,
            App,
            _,
            ProductAlternativeView,
            itemTpl,
            PimProductSelectDialog) {
    'use strict';

    module.exports = Marionette.CompositeView.extend({
      template: itemTpl,
      childViewContainer: '.alternatives-items',
      childView: ProductAlternativeView,

      initialize: function () {
      },

      events: {
        'click .btn-add-alternative': 'onBtnAddAlternativeClick'
      },

      onBtnAddAlternativeClick: function () {
        var productSelectDialog = new PimProductSelectDialog({
          multiSelect: false,
          displayLeaveButton: false
        });

        productSelectDialog.show({
          title: _.i18n('product.alternatives'),
          className: 'product-selection-dialog'
        });

        productSelectDialog.listenTo(productSelectDialog, 'products-selected', _.bind(function (products) {
          if (products && products.length > 0) {
            var selectedProductId = products[0].rowid;
            var model = App.request('pim:product-alternative:model', {
              productSecId: this.options.model.getCurrentResProduct().get('id'),
              alternativeProductId: selectedProductId
            });
            model.save().done(_.bind(function () {
              model.set('productSecId', this.options.model.getCurrentResProduct().get('id'), {silent: true});
              this.collection.add(model);
            }, this));
          }
        }, this));
      }
    });
  });

